import { getApiBaseUrl } from '../../utils/environment.mjs';
import axios from "axios";
const API_URL = getApiBaseUrl();

const CurrencyService = {
  /**
   * Get exchange rate for a specific date and currency
   * @param {string} date - Date in YYYY-MM-DD format
   * @param {string} currency - Currency code (e.g., EUR, GBP)
   * @returns {Promise} - Exchange rate data
   */
  getExchangeRate : async (date, currencyCode) => {
  try {
    const response = await axios.get(`${API_URL}/exchange-rate?date=${date}&currency=${currencyCode}`, {
      withCredentials: true
    });
    
    return response.data;
  } catch (error) {
    console.error('Exchange rate API error:', error);
    throw error;
  }
}

 
};


export default CurrencyService;

